/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Post request to path:
 * /v1/ua/sd_get_external_user_settings
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postSdGetExternalUserSettingsUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/sd_get_external_user_settings`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewSDExternalUserSettingsDetailsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Post request to path:
 * /v1/ua/sd_set_external_user_settings
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postSdSetExternalUserSettingsUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/sd_set_external_user_settings`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewSDExternalUserSettingsDetailsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Gets CodeTable from api:
 * /v1/codetables/{table_name}
 *
 * @param {string} table_name.
 * @param {any} callback function to call once this function has finished
 */
const getCodetablesByTableNameUtil = (table_name, callback) => {
  ReduxUtils.getModelDataFromRestAPI(callback, `v1/codetables/${table_name}`, models.CodeTable);
};

/**
 * Gets SDUAIsDuplicate from api:
 * /v1/ua/sd_user_email_linked_to_other_account/{emailAddress}
 *
 * @param {string} emailAddress.
 * @param {any} callback function to call once this function has finished
 */
const getSdUserEmailLinkedToOtherAccountByEmailAddressUtil = (emailAddress, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sd_user_email_linked_to_other_account/${emailAddress}`,
    models.SDUAIsDuplicate
  );
};

/**
 * Post request to path:
 * /v1/ua/sd_send_verification_code
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postSdSendVerificationCodeUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/sd_send_verification_code`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewSDExternalUserDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Post request to path:
 * /v1/ua/sd_verify_submitted_code
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postSdVerifySubmittedCodeUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/sd_verify_submitted_code`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewSDVerificationResultResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

export {
  postSdGetExternalUserSettingsUtil,
  postSdSetExternalUserSettingsUtil,
  getCodetablesByTableNameUtil,
  getSdUserEmailLinkedToOtherAccountByEmailAddressUtil,
  postSdSendVerificationCodeUtil,
  postSdVerifySubmittedCodeUtil,
};
